var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Page } from "../../lib/page-component";
import "../../components/header";
import "../../components/leftMenu";
import KnockoutModel from "../../lib/knockout_model";
import * as authorization from "../../lib/authorization";
import * as ajax from "../../app-lib/ajax_proxy";
import '../../lib/knockout_datePicker';
import "../../components/paging";
import './AddAcquiredBusiness.css';
import '../../lib/knockout_fileUpload';
var opponetModel = /** @class */ (function (_super) {
    __extends(opponetModel, _super);
    function opponetModel(root) {
        var _this = _super.call(this, "", root, {}) || this;
        _this.userId = ko.observable(authorization.getUserId()); //
        _this.leadurl = ko.observable('/api/company/upload');
        _this.isCheck = ko.observable(false); //是否是查看
        _this.dataId = ko.observable('0000'); //项目id  0000时新增 
        _this.local = ko.observableArray(); //省份列表
        _this.localid = ko.observable(); //省份obj
        _this.localnext = ko.observable(); //城市列表
        _this.localsomeid = ko.observable(); //城市obj
        _this.oneFileList = ko.observableArray([]); //第一个文件列表
        _this.twoFileList = ko.observableArray([]); //第二个文件列表
        // 企业概况
        _this.name = ko.observable(); //公司名称
        _this.corporateRepresentative = ko.observable(); //法人代表
        _this.registeredCapital = ko.observable(); //注册资本
        _this.beginTime = ko.observable(); //成立时间
        _this.businessTime = ko.observable(); //营业期限
        _this.companyType = ko.observable(); //公司类型
        _this.businessScope = ko.observable(); //经营范围
        _this.managementQualification = ko.observable(); //物业管理资质
        _this.position = ko.observable(); //总部位置 输入框
        _this.allArea = ko.observable(); //管理物业面积约
        _this.allCount = ko.observable(); //共多少项目
        _this.nowCount = ko.observable(); //现今在管
        _this.nowArea = ko.observable(); //多少面积
        _this.noCount = ko.observable(); //未入伙项目
        _this.noArea = ko.observable(); //未入伙面积
        _this.citySituation = ko.observable(); //在管项目分部城市情况
        _this.incomeSituation = ko.observable(); //附件
        _this.present = ko.observable(); //拟合作股份
        // 股东情况介绍
        _this.shareholdersNumber = ko.observable(); //股东人数
        _this.shareholdersBackground = ko.observable(); //股东背景
        _this.degree = ko.observable(); //各股东对彩生活模式及彩之云平台的认可度
        _this.remark = ko.observable(); //其他说明
        // 目前公司主要管理团队情况
        _this.memberSituation = ko.observable(); //目前公司现有员工情况
        _this.memberBackground = ko.observable(); // 核心管理人员及背景描述
        _this.otherRemark = ko.observable(); //其他说明
        _this.file = ko.observable(); //目前公司主要管理团队情况 附件
        // 目标公司项目情况
        _this.proList = ko.observable([{ projectName: ko.observable(), list: ko.observableArray([]) }]); //目标公司项目情况数组
        _this.isHaveFile = ko.observable(false); //是否已存在该文件
        _this.fileNameList = ko.observable([]); //文件名称数组
        return _this;
    }
    opponetModel.prototype.fileListDeduplication = function (arr, name) {
        var _this = this;
        this.fileNameList([]);
        arr.forEach(function (item) {
            _this.fileNameList().push(item.fileName);
        });
        this.fileNameList(this.fileNameList());
        if (this.fileNameList().indexOf(name) < 0) {
            this.isHaveFile(false);
        }
        else {
            this.isHaveFile(true);
        }
    };
    // 上传第一个文件列表
    opponetModel.prototype.ponUploadedOne = function (d, r) {
        for (var i = 0; i < r.data.length; i++) {
            this.fileListDeduplication(this.oneFileList(), r.data[i].fileName);
            if (this.isHaveFile()) {
                window.popBox.show('重复文件已过滤');
            }
            else {
                this.oneFileList().push(r.data[i]);
            }
        }
        this.oneFileList(this.oneFileList());
    };
    // 删除第一个文件列表
    opponetModel.prototype.deleteOneList = function (d, r) {
        for (var i = 0; i < this.oneFileList().length; i++) {
            if (d.fileName == this.oneFileList()[i].fileName) {
                this.oneFileList().splice(i, 1);
            }
        }
        this.oneFileList(this.oneFileList());
    };
    // 上传第二个文件列表
    opponetModel.prototype.ponUploadedTwo = function (d, r) {
        for (var i = 0; i < r.data.length; i++) {
            // this.twoFileList().push(r.data[i]);
            this.fileListDeduplication(this.twoFileList(), r.data[i].fileName);
            if (this.isHaveFile()) {
                window.popBox.show('重复文件已过滤');
            }
            else {
                this.twoFileList().push(r.data[i]);
            }
        }
        this.twoFileList(this.twoFileList());
    };
    // 删除第二个文件列表
    opponetModel.prototype.deleteTwoList = function (d, r) {
        for (var i = 0; i < this.twoFileList().length; i++) {
            if (d.fileName == this.twoFileList()[i].fileName) {
                this.twoFileList().splice(i, 1);
            }
        }
        this.twoFileList(this.twoFileList());
    };
    // 上传第三个文件列表
    opponetModel.prototype.ponUploadedThree = function (d, index, res) {
        // console.log(d, index,res);
        for (var i = 0; i < res.data.length; i++) {
            // this.proList()[index].list().push(res.data[i]);
            this.fileListDeduplication(this.proList()[index].list(), res.data[i].fileName);
            if (this.isHaveFile()) {
                window.popBox.show('重复文件已过滤');
            }
            else {
                this.proList()[index].list().push(res.data[i]);
            }
        }
        this.proList()[index].list((this.proList()[index].list()));
        // console.log(this.proList()[index].list(), '---文件列表');
    };
    // 删除第三个文件列表
    opponetModel.prototype.deleteThreeList = function (d, pIndex, pData, p) {
        // console.log(d, pIndex, pData, p);
        for (var i = 0; i < pData.list().length; i++) {
            if (d.fileName == pData.list()[i].fileName) {
                pData.list().splice(i, 1);
            }
        }
        this.proList()[pIndex].list((this.proList()[pIndex].list()));
    };
    // 下载第一个附件列表
    opponetModel.prototype.getOneFile = function (d) {
        console.log(d);
        window.open(d.fileUrl);
    };
    // 下载第二个附件列表
    opponetModel.prototype.getTwoFile = function (d) {
        window.open(d.fileUrl);
    };
    // 下载第三个附件列表
    opponetModel.prototype.getThreeFile = function (d) {
        window.open(d.fileUrl);
    };
    // 增加目标公司项目数组
    opponetModel.prototype.addCompany = function (d) {
        this.proList().push({ projectName: ko.observable(), list: ko.observableArray([]) });
        this.proList(this.proList());
    };
    // 删除目标公司项目数组
    opponetModel.prototype.deleteCompany = function (d, r) {
        this.proList().splice(d, 1);
        this.proList(this.proList());
    };
    // 返回
    opponetModel.prototype.goBack = function () {
        history.go(-1);
        this.resetData();
    };
    // 新建，编辑提交
    opponetModel.prototype.subData = function () {
        var _this = this;
        // 必填项校验
        if (!this.name()) {
            return window.popBox.show('请填写公司名称');
        }
        // if (!this.companyType()) {
        //     return window.popBox.show('请填写公司类型');
        // }
        // if (!this.managementQualification()) {
        //     return window.popBox.show('请填写物业管理资质');
        // }
        // if (!this.position()) {
        //     return window.popBox.show('请填写具体总部位置');
        // }
        if (this.registeredCapital()) {
            if (this.registeredCapital().length > 10) {
                return window.popBox.show('注册资本不能大于10位数');
            }
        }
        if (this.allArea() && this.allArea().length > 20) {
            return window.popBox.show('管理物业面积不能大于20位数');
        }
        if (this.allCount() && this.allCount().length > 10) {
            return window.popBox.show('管理物业项目不能大于10位数');
        }
        if (this.nowArea() && this.nowArea().length > 20) {
            return window.popBox.show('现今在管面积不能大于20位数');
        }
        if (this.nowCount() && this.nowCount().length > 10) {
            return window.popBox.show('现今在管项目不能大于10位数');
        }
        if (this.noCount() && this.noCount().length > 10) {
            return window.popBox.show('未入伙项目不能大于10位数');
        }
        if (this.noArea() && this.noArea().length > 20) {
            return window.popBox.show('未入伙项目面积不能大于20位数');
        }
        if (this.shareholdersNumber() && this.shareholdersNumber().length > 10) {
            return window.popBox.show('股东人数不能大于10位数');
        }
        var incomeSituationStr = '';
        for (var i = 0; i < this.oneFileList().length; i++) {
            if (i == 0) {
                incomeSituationStr = this.oneFileList()[i].fileId;
            }
            else {
                incomeSituationStr = incomeSituationStr + ',' + this.oneFileList()[i].fileId;
            }
        }
        var fileStr = '';
        for (var n = 0; n < this.twoFileList().length; n++) {
            if (n == 0) {
                fileStr = this.twoFileList()[n].fileId;
            }
            else {
                fileStr = fileStr + ',' + this.twoFileList()[n].fileId;
            }
        }
        var project = [];
        // if()
        for (var m = 0; m < this.proList().length; m++) {
            var str = void 0;
            if (this.proList()[m].projectName() || this.proList()[m].list().length > 0) {
                if (!this.proList()[m].projectName()) {
                    return window.popBox.show('第' + Number(m + 1) + '个项目名为空');
                }
                if (this.proList()[m].list().length < 1) {
                    return window.popBox.show('第' + Number(m + 1) + '个项目未上传文件');
                }
            }
            for (var x = 0; x < this.proList()[m].list().length; x++) {
                if (x == 0) {
                    str = this.proList()[m].list()[x].fileId;
                }
                else {
                    str = str + ',' + this.proList()[m].list()[x].fileId;
                }
            }
            if (this.proList()[m].projectName() && this.proList()[m].list().length > 0) {
                project.push({ projectName: this.proList()[m].projectName(), file: str });
            }
            // if(!this.proList()[m].projectName() && this.proList()[m].list().length <1){
            //     project=[];
            // }
        }
        // 总部位置
        var pt = '';
        if (this.position()) {
            pt = this.localid().name + ',' + this.localsomeid().name + ',' + this.position();
        }
        else {
            pt = this.localid().name + ',' + this.localsomeid().name + ',' + ' ';
        }
        // console.log(project,'-----------目标项目数组');
        ajax.post('/api/company/' + this.dataId(), {
            authorId: authorization.getUserId(),
            authorName: authorization.getUsername(),
            // 企业概况
            name: this.name(),
            corporateRepresentative: this.corporateRepresentative(),
            registeredCapital: this.registeredCapital(),
            beginTime: this.beginTime(),
            businessTime: this.businessTime(),
            companyType: this.companyType(),
            businessScope: this.businessScope(),
            managementQualification: this.managementQualification(),
            position: pt,
            allArea: this.allArea(),
            allCount: this.allCount(),
            nowCount: this.nowCount(),
            nowArea: this.nowArea(),
            noCount: this.noCount(),
            noArea: this.noArea(),
            citySituation: this.citySituation(),
            incomeSituation: incomeSituationStr,
            present: this.present(),
            // 股东情况介绍
            shareholdersNumber: this.shareholdersNumber(),
            shareholdersBackground: this.shareholdersBackground(),
            degree: this.degree(),
            remark: this.remark(),
            // 目前公司主要管理团队情况
            memberSituation: this.memberSituation(),
            memberBackground: this.memberBackground(),
            otherRemark: this.otherRemark(),
            file: fileStr,
            // 目标公司项目情况
            project: project,
        }).then(function (d) {
            if (d.status == '0') {
                if (_this.dataId() == '0000') {
                    window.popBox.show('提交成功').then(function (d) {
                        _this.goBack();
                    });
                }
                else {
                    window.popBox.show('编辑成功').then(function (d) {
                        _this.goBack();
                    });
                }
            }
        }).catch(function (err) {
            if (err.status == '2') {
                window.popBox.show(err.message);
            }
        });
    };
    // 取消
    opponetModel.prototype.quick = function () {
        this.resetData();
        this.goBack();
    };
    // 重置
    opponetModel.prototype.resetData = function () {
        if (this.dataId() == '0000') {
            this.name(''); //公司名称
            this.corporateRepresentative(''); //法人代表
            this.registeredCapital(''); //注册资本
            this.beginTime(''); //成立时间
            this.businessTime(''); //营业期限
            this.companyType(''); //公司类型
            this.businessScope(''); //经营范围
            this.managementQualification(''); //物业管理资质
            this.position(''); //总部位置 输入框
            this.allArea(''); //管理物业面积约
            this.allCount(''); //共多少项目
            this.nowCount(''); //现今在管
            this.nowArea(''); //多少面积
            this.noCount(''); //未入伙项目
            this.noArea(''); //未入伙面积
            this.citySituation(''); //在管项目分部城市情况
            this.incomeSituation(''); //附件
            this.present(''); //拟合作股份
            // 股东情况介绍
            this.shareholdersNumber(''); //股东人数
            this.shareholdersBackground(''); //股东背景
            this.degree(''); //各股东对彩生活模式及彩之云平台的认可度
            this.remark(''); //其他说明
            // 目前公司主要管理团队情况
            this.memberSituation(''); //目前公司现有员工情况
            this.memberBackground(''); // 核心管理人员及背景描述
            this.otherRemark(''); //其他说明
            this.file(''); //目前公司主要管理团队情况 附件
            // 目标公司项目情况
            this.proList([{ projectName: ko.observable(), list: ko.observableArray([]) }]); //目标公司项目情况数组
            this.oneFileList([]); //第一个文件列表
            this.twoFileList([]); //第二个文件列表
        }
        else {
            this.getMarketData();
        }
    };
    // 获取数据
    opponetModel.prototype.getMarketData = function () {
        var _this = this;
        ajax.get('/api/company/' + this.dataId()).then(function (d) {
            _this.name(d.data.sistuation.name); //公司名称
            _this.corporateRepresentative(d.data.sistuation.corporateRepresentative); //法人代表
            _this.registeredCapital(d.data.sistuation.registeredCapital); //注册资本
            _this.beginTime(d.data.sistuation.beginTime); //成立时间
            _this.businessTime(d.data.sistuation.businessTime); //营业期限
            _this.companyType(d.data.sistuation.companyType); //公司类型
            _this.businessScope(d.data.sistuation.businessScope); //经营范围
            _this.managementQualification(d.data.sistuation.managementQualification); //物业管理资质
            // this.position(d.data.sistuation.position);//总部位置 输入框
            if (d.data.sistuation.position.length > 0) {
                for (var m = 0; m < _this.local().length; m++) {
                    if (_this.local()[m].name == d.data.sistuation.position.substring(0, d.data.sistuation.position.indexOf(','))) {
                        _this.localid(_this.local()[m]);
                    }
                }
                _this.getCity(_this.localid().id, d.data.sistuation.position.substring(d.data.sistuation.position.indexOf(',') + 1, d.data.sistuation.position.lastIndexOf(',')));
                _this.position(d.data.sistuation.position.substring(d.data.sistuation.position.lastIndexOf(',') + 1, d.data.sistuation.position.length)); //总部位置 输入框
            }
            else {
                _this.position(d.data.sistuation.position); //总部位置 输入框
            }
            _this.allArea(d.data.sistuation.allArea); //管理物业面积约
            _this.allCount(d.data.sistuation.allCount); //共多少项目
            _this.nowCount(d.data.sistuation.nowCount); //现今在管
            _this.nowArea(d.data.sistuation.nowArea); //多少面积
            _this.noCount(d.data.sistuation.noCount); //未入伙项目
            _this.noArea(d.data.sistuation.noArea); //未入伙面积
            _this.citySituation(d.data.sistuation.citySituation); //在管项目分部城市情况
            // this.incomeSituation(d.data.sistuation.incomeSituation);//附件
            _this.present(d.data.sistuation.present); //拟合作股份
            // 股东情况介绍
            _this.shareholdersNumber(d.data.sistuation.shareholdersNumber); //股东人数
            _this.shareholdersBackground(d.data.sistuation.shareholdersBackground); //股东背景
            _this.degree(d.data.sistuation.degree); //各股东对彩生活模式及彩之云平台的认可度
            _this.remark(d.data.sistuation.remark); //其他说明
            // 目前公司主要管理团队情况
            _this.memberSituation(d.data.sistuation.memberSituation); //目前公司现有员工情况
            _this.memberBackground(d.data.sistuation.memberBackground); // 核心管理人员及背景描述
            _this.otherRemark(d.data.sistuation.otherRemark); //其他说明
            // this.file(d.data.);//目前公司主要管理团队情况 附件
            // 目标公司项目情况
            //目标公司项目情况数组
            if (d.data.project.length > 0) {
                // this.proList(d.data.project);
                _this.proList([]);
                for (var n = 0; n < d.data.project.length; n++) {
                    _this.proList().push({ projectName: ko.observable(d.data.project[n].projectName), list: ko.observableArray(d.data.project[n].list) });
                }
            }
            _this.proList(_this.proList());
            _this.oneFileList(d.data.sistuation.incomeList); //第一个文件列表
            _this.twoFileList(d.data.sistuation.teamList); //第二个文件列表
        });
    };
    // 获取省份
    opponetModel.prototype.getPrivine = function () {
        var _this = this;
        ajax.get('/api/ice/local', { pid: 1 }).then(function (d) {
            _this.local(d.data);
        });
    };
    //省份二级联动
    opponetModel.prototype.changelocal = function () {
        var _this = this;
        var id = this.localid().id;
        ajax.get("/api/ice/local", { pid: id }).then(function (d) {
            _this.localnext(d.data);
        });
    };
    opponetModel.prototype.getCity = function (id, city) {
        var _this = this;
        ajax.get("/api/ice/local", { pid: id }).then(function (d) {
            _this.localnext(d.data);
            for (var n = 0; n < _this.localnext().length; n++) {
                if (_this.localnext()[n].name == city) {
                    _this.localsomeid(_this.localnext()[n]);
                }
            }
        });
        // setTimeout(() => {
        // }, 300);
    };
    opponetModel.prototype.scrollTop = function () {
        this.container.querySelector('.AddAcquiredBusiness_body').scrollTop = 0;
    };
    return opponetModel;
}(KnockoutModel));
var opModel = /** @class */ (function (_super) {
    __extends(opModel, _super);
    function opModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    opModel.prototype.init = function () {
        this.vm = new opponetModel(this.container.querySelector('.AddAcquiredBusiness'));
        this.vm.bind();
    };
    opModel.prototype.update = function (arg) {
        var _this = this;
        this.vm.dataId('0000');
        this.vm.resetData();
        this.vm.scrollTop();
        this.vm.getPrivine();
        if (arg.routeData.query.isCheck) {
            if (arg.routeData.query.isCheck == 'yes') {
                this.vm.isCheck(true);
            }
            else {
                this.vm.isCheck(false);
            }
        }
        if (arg.routeData.query.dataId) {
            this.vm.dataId(arg.routeData.query.dataId);
            setTimeout(function () {
                _this.vm.getMarketData();
            }, 500);
        }
        return Promise.resolve();
    };
    opModel.prototype.onInitComplete = function () {
    };
    return opModel;
}(Page));
export default opModel;
